import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'packagingFilter'
})
export class PackagingFilter implements PipeTransform {
  constructor() {

  }

  transform(products: any[], packageType: string, nurseryProducts: any[], nurseryProductDetailed: any[]) {
    // console.log('containerSizeFilter', nurseryProductDetailed, containerSize);
    if (!packageType) {
      return products;
    }

    return products.filter(p => {
      const nurseryProduct = nurseryProducts.find(np => np.product_id === p.id);
      if (!nurseryProduct) {
        return false;
      }
      const details = nurseryProductDetailed.find(pd => pd.nursery_product_id === nurseryProduct.id);
      const predicate = details.packaging_type.name.indexOf(packageType) >= 0;
      if (predicate) {
        // console.log(details.container_size, containerSize);
      }
      return predicate;
    });
  }
}